import { Component } from '@angular/core';

@Component({
    selector: 'app-registration-summary',
    templateUrl: './registration-summary.component.html',
    styleUrls: ['./registration-summary.component.scss'],
    standalone: false
})
export class RegistrationSummaryComponent {

}
